// extracted by mini-css-extract-plugin
module.exports = {"vUiHue":"#ddd","wrapper":"List__wrapper___TGB5e","wrapper-inside":"List__wrapper-inside___2vmHV","topShadow":"List__topShadow___MoX7Y","bottomShadow":"List__bottomShadow___1N2hX"};